import { TOOLS } from '@config/environment';

const TailwindIndicator = () => {
  if (TOOLS.SHOW_TAILWIND_INDICATOR !== 'true') return null;

  return (
    <div className="fixed bottom-1 left-1 z-50 flex h-6 w-6 items-center justify-center rounded-lg bg-background border border-border p-4 font-mono text-xs text-accent-foreground font-bold">
      <div className="block sm:hidden">xs</div>
      <div className="hidden sm:block md:hidden">sm</div>
      <div className="hidden md:block lg:hidden">md</div>
      <div className="hidden lg:block xl:hidden">lg</div>
      <div className="hidden xl:block 2xl:hidden">xl</div>
      <div className="hidden 2xl:block">2xl</div>
    </div>
  );
};

export { TailwindIndicator };
